module.exports = __webpack_public_path__ + "static/img/eng-fa-logo.9e55c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eng-fa-logo.png
// module id = RRyZ
// module chunks = 94